import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cookiesModalComponent from "./cookiesModal.component";

let cookiesModalModule = angular.module('cookiesModal', [
  uiRouter
])

  .component('cookiesModal', cookiesModalComponent)

  .name;

export default cookiesModalModule;



// WEBPACK FOOTER //
// ./client/app/common/cookiesModal/cookiesModal.js